import SectionTitle from '@/components/feature/SectionTitle';
import ScrollReveal from '@/components/feature/ScrollReveal';

const SEGMENTS = [
  { icon: 'ri-file-paper-2-line', name: 'Papel e Celulose' },
  { icon: 'ri-hammer-line', name: 'Mineração' },
  { icon: 'ri-ship-line', name: 'Portos' },
  { icon: 'ri-building-2-line', name: 'Construção Pesada' },
  { icon: 'ri-plant-line', name: 'Agronegócio' },
  { icon: 'ri-tree-line', name: 'Florestal' },
  { icon: 'ri-settings-5-line', name: 'Indústria' },
];

export default function SegmentsSection() {
  return (
    <section id="segmentos" className="py-14 md:py-18 bg-background-100">
      <div className="max-w-container mx-auto px-4 md:px-6">
        <ScrollReveal>
          <SectionTitle
            overline="Onde atuamos"
            title="Segmentos Atendidos"
            description="Atuamos em diferentes segmentos industriais, oferecendo soluções hidráulicas para equipamentos móveis e sistemas industriais de alta criticidade."
          />
        </ScrollReveal>
        <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-4 md:gap-5">
          {SEGMENTS.map((segment, i) => (
            <ScrollReveal key={i} delay={i * 70}>
              <div className="group flex flex-col items-center text-center p-5 md:p-6 bg-background-50 rounded-lg border border-background-200/60 hover:border-primary-200/50 hover:bg-background-50 transition-all duration-300 cursor-default">
                <div className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-50 text-primary-500 mb-3 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                  <i className={`${segment.icon} text-xl`}></i>
                </div>
                <span className="text-sm font-semibold text-foreground-800 whitespace-nowrap">
                  {segment.name}
                </span>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}